import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchAuditLogs } from '../../services/api/auditLogService';

export const loadAuditLogs = createAsyncThunk('auditLogs/load', async () => fetchAuditLogs());

const auditLogsSlice = createSlice({
  name: 'auditLogs',
  initialState: { status: 'idle', error: null, items: [] },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadAuditLogs.pending, (state) => { state.status = 'loading'; })
      .addCase(loadAuditLogs.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.items = action.payload.content || action.payload;
      })
      .addCase(loadAuditLogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  }
});

export default auditLogsSlice.reducer;
